import { NavLink } from "react-router-dom";
import { Home, LayoutGrid, PackageCheck, PackagePlus, Search, CalendarDays } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { hasPermission } from "../lib/permissions";

const item = "flex-1 min-w-0 flex flex-col items-center justify-center gap-0.5 h-full text-[10px] font-bold uppercase tracking-wider transition-colors";

export const BottomNav = ({ onMenu, onSearch }) => {
  const { user } = useAuth();
  const isDriver = user?.role === "kierowca";
  const links = [
    (isDriver || hasPermission(user, "dashboard")) && { to: "/", label: isDriver ? "Portfel" : "Pulpit", icon: Home, end: true, id: "home" },
    { to: "/zaladunek", label: "Załadunek", icon: PackagePlus, id: "loading" },
    hasPermission(user, "deliveries") && { to: isDriver ? "/zlecenia?view=swipe" : "/zlecenia", label: "Zlecenia", icon: PackageCheck, id: "deliveries" },
    isDriver && hasPermission(user, "schedule") && { to: "/schedule", label: "Grafik", icon: CalendarDays, id: "schedule" },
  ].filter(Boolean);
  return (
    <nav data-testid="bottom-nav" className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur-md border-t border-zinc-200 pb-[env(safe-area-inset-bottom)]">
      <div className="flex h-16 px-1">
        {links.map(({ to, label, icon: Icon, end, id }) => (
          <NavLink key={id} to={to} end={end} data-testid={`bottom-nav-${id}`} className={({ isActive }) => `${item} ${isActive ? "text-brand" : "text-zinc-500 active:text-zinc-900"}`}>
            {({ isActive }) => <>
              <span className={`flex items-center justify-center w-12 h-7 rounded-full transition-colors ${isActive ? "bg-brand/10" : ""}`}><Icon className="w-5 h-5" /></span>
              <span className="truncate max-w-full">{label}</span>
            </>}
          </NavLink>
        ))}
        {!isDriver && (
          <button type="button" data-testid="bottom-nav-search" onClick={onSearch} className={`${item} text-zinc-500 active:text-zinc-900`}>
            <span className="flex items-center justify-center w-12 h-7"><Search className="w-5 h-5" /></span>Szukaj
          </button>
        )}
        <button type="button" data-testid="bottom-nav-menu" onClick={onMenu} className={`${item} text-zinc-500 active:text-zinc-900`}>
          <span className="flex items-center justify-center w-12 h-7"><LayoutGrid className="w-5 h-5" /></span>Menu
        </button>
      </div>
    </nav>
  );
};
